<template>
    <div class="dashboard">
        <el-row :gutter="20">
            <el-col :span="12">
                <el-card class="box-card">
                    <div class="line"><i class="el-icon-circle-check" style="color: #5daf34"></i>
                        <p>成功数:<strong class="success">{{tableData.triggerCountSucTotal}}</strong></p>
                    </div>

                </el-card>
            </el-col>
            <el-col :span="12">
                <el-card class="box-card">
                    <div class="line"><i class="el-icon-circle-close" style="color: red"></i>
                        <p>失败数:<strong class="warning">{{tableData.triggerCountFailTotal}}</strong></p>
                    </div>
                </el-card>
            </el-col>
            <el-col :span="24" style="margin-top: 10px">
                <el-card class="box-card">
                    <div slot="header">
                        <span>调度报表</span>
                        <span class="block" style="float: right">
            <el-date-picker
                    v-model="value7"
                    type="daterange"
                    align="right"
                    unlink-panels
                    size="small"
                    value-format="yyyy/MM/dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions2"
                    @change="getList"
            >
            </el-date-picker>
          </span>
                    </div>
                    <div id="container"></div>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import {Line} from '@antv/g2plot';

    export default {
        name: "datasource",
        data() {
            return {
                line:null,
                tableData: [],
                pickerOptions2: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                value7: []
            }
        },
        methods: {
            getDateTime(time, split) {
                let date = new Date(time)
                let year = date.getFullYear()
                let month = date.getMonth() + 1
                split = '/'
                return [year, month, 1].map(num => this.formatNumber(num)).join(split)
            },
            getDateTimeNew(time) {
                let date = new Date(time)
                let year = date.getFullYear()
                let month = (date.getMonth() + 1) > 10 ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))
                let day = date.getDate() > 10 ? date.getDate() : ('0' + date.getDate())
                return `${year}/${month}/${day}`
            },
            formatNumber(number) {
                return String(number)[1] ? String(number) : `0${number}`
            },
            getList() {
                debugger
                const paramsData = {
                    startDate: this.value7[0] + ' 00:00:00',
                    endDate: this.value7[1] + ' 23:59:59'
                }
                this.axios({
                    method: 'get',
                    url: '/log/chartInfo',
                    params: paramsData
                }).then((res) => {
                    this.tableData = res.data
                    this.initChart();
                }).catch(error => {
                    console.error(error)
                })
            },
            initChart() {
                const data = []
                this.tableData.triggerDayList.map((item, key) => {
                    data.push({
                        dateTime: item,
                        value: this.tableData.triggerDayCountSucList[key],
                        text: '成功',
                    })
                    data.push({
                        dateTime: item,
                        value: this.tableData.triggerDayCountFailList[key],
                        text: '失败',
                    })
                })
                if(!this.line){
                    this.line = new Line('container', {
                        data,
                        xField: 'dateTime',
                        yField: 'value',
                        seriesField: 'text',
                        xAxis: {
                            type: 'time',
                        },
                        color:({text})=>{
                            if(text=='成功'){
                                return '#5daf34';
                            }
                            return 'red';
                        }
                    });


                    this.line.render();

                }else{
                    this.line.changeData(data);
                }

            }
        },
        created() {
            this.value7 = [this.getDateTime(new Date()), this.getDateTimeNew(new Date())]
            this.getList()
        },
    }
</script>

<style scoped lang="scss">
    .dashboard {

        i {
            font-size: 48px;
        }
        .box-card {
            div.line {
                display: flex;
                i {
                    flex: 1;
                    float: left
                }
                p {
                    font-size: 34px
                }
                strong.success {
                    color: #5daf34
                }
                strong.warning {
                    color: red
                }
            }
        }
    }
</style>
